export default __webpack_public_path__ + "static/media/cross_on.6a5d799f.svg";